import React, { Component, Fragment } from "react";
import Header from "../Header";
import SideMenu from "../SideMenu";
import Body from "../Body";
// import Footer from "../Footer/Footer";
import { getProperty } from "../../actions/propertyAction";
import { connect } from "react-redux";
import Spinner from "../common/Spinner";
import isEmpty from "../../validation/is-empty";

export class Property extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      this.props.getProperty(this.props.match.params.id);
    }
  }

  render() {
    const { properties, property } = this.props.property;
    console.log(property);
    return (
      <div className="skin-blue ">
        <div className="wrapper">
          <Header />
          <SideMenu active="user" />
          <Body>
            <section className="content-header">
              <h1>Properties</h1>
              <ol className="breadcrumb">
                <li>
                  <a /* href="#" */>
                    <i className="fa fa-dashboard"></i> Home
                  </a>
                </li>
                <li className="active">Properties</li>
              </ol>
            </section>

            {!isEmpty(property) ? (
              <section className="content">
                <div className="row">
                  <div className="col-md-offset-1 col-md-4 col-md-offset-1">
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1">Title</label>
                      <input
                        type="text"
                        className="form-control"
                        id="title"
                        name="title"
                        placeholder="Title"
                        readOnly
                        value={property.title}
                      />
                    </div>
                  </div>
                  <div className="col-md-offset-1 col-md-4 col-md-offset-1">
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1">User Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="title"
                        name="title"
                        placeholder="Title"
                        readOnly
                        value={property.user.name}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-offset-1 col-md-4 col-md-offset-1">
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1">Description</label>
                      <textarea
                        className="form-control"
                        id="description"
                        name="description"
                        placeholder="Description"
                        readOnly
                      >
                        {property.description}
                      </textarea>
                      {/*                   <input
                        type="text"
                        className="form-control"
                        id="description"
                        name="description"
                        placeholder="Description"
                        readOnly
                        value={property.description}
                      /> */}
                    </div>
                  </div>
                  <div className="col-md-offset-1 col-md-4 col-md-offset-1">
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1">No Of Basement</label>
                      <input
                        type="text"
                        className="form-control"
                        id="no_of_basement"
                        name="no_of_basement"
                        placeholder="No Of Basement"
                        readOnly
                        value={property.no_of_basement}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-offset-1 col-md-4 col-md-offset-1">
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1">No Of Bathroom</label>
                      <input
                        type="text"
                        className="form-control"
                        id="no_of_bathroom"
                        name="no_of_bathroom"
                        placeholder="No Of Bathroom"
                        readOnly
                        value={property.no_of_bathroom}
                      />
                    </div>
                  </div>
                  <div className="col-md-offset-1 col-md-4 col-md-offset-1">
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1">Is Kitchen</label>
                      <input
                        type="text"
                        className="form-control"
                        id="is_kitchen"
                        name="is_kitchen"
                        placeholder="Is Kitchen"
                        readOnly
                        value={property.is_kitchen ? true : false}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-offset-1 col-md-4 col-md-offset-1">
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1">Is Living Room</label>
                      <input
                        type="text"
                        className="form-control"
                        id="is_living_room"
                        name="is_living_room"
                        placeholder="Is Living Room"
                        readOnly
                        value={property.is_living_room ? true : false}
                      />
                    </div>
                  </div>
                  <div className="col-md-offset-1 col-md-4 col-md-offset-1">
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1">Is Sale</label>
                      <input
                        type="text"
                        className="form-control"
                        id="is_sale"
                        name="is_sale"
                        placeholder="Is Sale"
                        readOnly
                        value={property.is_sale ? true : false}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-offset-1 col-md-4 col-md-offset-1">
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1">Address</label>
                      <input
                        type="text"
                        className="form-control"
                        id="address"
                        name="address"
                        placeholder="Address"
                        readOnly
                        value={`${property.address}, ${property.address1}`}
                      />
                    </div>
                  </div>
                  <div className="col-md-offset-1 col-md-4 col-md-offset-1">
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1">City</label>
                      <input
                        type="text"
                        className="form-control"
                        id="city"
                        name="city"
                        placeholder="City"
                        readOnly
                        value={property.city ? property.city.name : ""}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-offset-1 col-md-4 col-md-offset-1">
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1">State</label>
                      <input
                        type="text"
                        className="form-control"
                        id="state"
                        name="state"
                        placeholder="State"
                        readOnly
                        value={property.state ? property.state.name : ""}
                      />
                    </div>
                  </div>
                  <div className="col-md-offset-1 col-md-4 col-md-offset-1">
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1">Country</label>
                      <input
                        type="text"
                        className="form-control"
                        id="country"
                        name="country"
                        placeholder="Country"
                        readOnly
                        value={property.country ? property.country.name : ""}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-offset-1 col-md-4 col-md-offset-1">
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1">Latitude</label>
                      <input
                        type="text"
                        className="form-control"
                        id="latitude"
                        name="latitude"
                        placeholder="Latitude"
                        readOnly
                        value={property.latitude}
                      />
                    </div>
                  </div>
                  <div className="col-md-offset-1 col-md-4 col-md-offset-1">
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1">Longitude</label>
                      <input
                        type="text"
                        className="form-control"
                        id="longitude"
                        name="longitude"
                        placeholder="Longitude"
                        readOnly
                        value={property.longitude}
                      />
                    </div>
                  </div>
                </div>
              </section>
            ) : (
              <Spinner />
            )}
            {/*   {isShowViewUser ? (
              <ViewUser
                handleCancelViewUser={this.handleCancelViewUser}
                user={selectUser}
              />
            ) : null}
            {isShowEditUser ? (
              <EditUser
                handleCancelEditUser={this.handleCancelEditUser}
                user={selectUser}
              />
            ) : null} */}
          </Body>
          {/* <Footer /> */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  property: state.property,
  errors: state.errors
});

export default connect(mapStateToProps, {
  getProperty
})(Property);



// WEBPACK FOOTER //
// ./src/components/Property/ViewProperty.js